import React from "react";

/**
 * container for all text in pricing element
 */
export function PricingText() {
  return (
    <div className="text-center py-8 text-slate-300">
      <h2 className="text-3xl uppercase">Pricing</h2>
      <h3 className="text-2xl sm:text-5xl font-bold text-white py-8">
        The right price for your research.
      </h3>
      <p className="sm:text-3xl">
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Doloremque
        eveniet provident ut. Possimus tempore quasi dolore maiores fuga
        explicabo dolorum, facilis nisi doloribus? Maxime quis quia fugiat
        libero sed quibusdam.
      </p>
    </div>
  );
}
